import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {ToolTip} from '../tooltip/tooltip'
import {AvatarBase} from './avatar-base'

interface Props {
  users: UserProxy[]
  content: React.ReactElement
  arrowPosition: 'up-left'
}

export const TwContainer = tw.div`
  flex
  flex-col
  min-w-234
`

export const TwHeader = tw.div`
  text-invert
  text-14
  leading-4
  font-semibold

  pb-16
  mb-16

  border-0
  border-b-1
  border-solid
  border-grey-l60
`

export const TwContainerContent = tw.div`
  flex
  flex-col
  gap-16
`

export const TwContainerItem = tw.div`
  flex gap-8
`

export const TwContainerUserName = tw.div`
  text-invert
  text-12
  leading-4
`

export const AvatarGroupTooltip = (props: Props) => {
  const {users, content, arrowPosition} = props

  const tooltipContent = (
    <TwContainer>
      <TwHeader>{`${Lang.msg.subtask.assignedUsers} (${users.length})`}</TwHeader>

      <WithPerfectScrollbar className="max-h-400">
        <TwContainerContent>
          {users.map(user => (
            <TwContainerItem key={user.userId}>
              <AvatarBase
                key={user.userId}
                user={user}
                size={16}
                hideStatus
                hideHint
                hideOutline
              />
              <TwContainerUserName>{user.userName}</TwContainerUserName>
            </TwContainerItem>
          ))}
        </TwContainerContent>
      </WithPerfectScrollbar>
    </TwContainer>
  )

  return (
    <ToolTip
      dark
      paddings={16}
      tooltipChildren={tooltipContent}
      tooltipPosition="down"
      arrowPosition={arrowPosition}
    >
      {content}
    </ToolTip>
  )
}
